import { Rule } from "rc-field-form/lib/interface";

const getRulesValidationField = (
    fieldName: string,
    requiredFields: string[] | undefined,
    innitRules?: Rule[],
    customMessage?: string): Rule[] => {
    if (!innitRules) {
        innitRules = [];
    }

    if (requiredFields && requiredFields.indexOf(fieldName) !== -1) {
        if (customMessage) {
            innitRules.push({ required: true, message: customMessage });
        } else {
            innitRules.push({ required: true });
        }

    }

    return innitRules;
}

export const VALIDATION_UTIL = {
    getRulesValidationField
}